module.exports = __webpack_public_path__ + "static/media/wrong.e3f4153a.png";